import { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import ContainerPage from "../../components/Containers/ContainerPage";
import TitlePage from "../../components/Texts/TitlePage";
import { useTranslationApp } from "../../lib/i18next";
import { useSelectorApp } from "../../lib/redux";
import useOwnerFormSubmissions from "../../hooks/useOwnerFormSubmissions";
import OwnerFormSubmissionsTable from "./components/OwnerFormSubmissionsTable";
import {
  ERROR_OCCURRED,
  OWNER_DASHBOARD_NAV_FORM,
} from "../../i18n/keysTranslations";

const OwnerFormSubmissionsBrief = () => {
  const { t } = useTranslationApp();
  const navigate = useNavigate();
  const { theme } = useSelectorApp((state) => state.ui);
  const { rows, loading, loadingMore, hasMore, error, loadMore } =
    useOwnerFormSubmissions();

  const { ref: lastItemRef, inView } = useInView({
    triggerOnce: false,
    rootMargin: "80px 0px",
  });

  useEffect(() => {
    if (!inView || !hasMore || loading || loadingMore) return;
    loadMore();
  }, [inView, hasMore, loading, loadingMore, loadMore]);

  const onViewDetails = ({ formId, submissionType }) => {
    const encoded = encodeURIComponent(formId);
    if (submissionType === "enterpriseIntake") {
      navigate(`/enterprise-leads/${encoded}`);
      return;
    }
    navigate(`/leads/${encoded}`);
  };

  return (
    <ContainerPage hasMarginBottom={false}>
      <Helmet>
        <title>{`${theme.nameBusiness} - ${t(OWNER_DASHBOARD_NAV_FORM)}`}</title>
      </Helmet>
      <Box sx={{ width: "100%", px: 3, mt: 4, flexShrink: 0 }}>
        <TitlePage sx={{ mb: 2 }}>{t(OWNER_DASHBOARD_NAV_FORM)}</TitlePage>

        {error ? (
          <Typography color="error" sx={{ mb: 2 }}>
            {t(ERROR_OCCURRED)}
          </Typography>
        ) : null}
      </Box>

      <Box sx={{ width: "100%", px: 3, mb: 4, minWidth: 0 }}>
        <OwnerFormSubmissionsTable
          rows={rows}
          loading={loading}
          loadingMore={loadingMore}
          hasMore={hasMore}
          lastItemRef={lastItemRef}
          onViewDetails={onViewDetails}
        />
      </Box>
    </ContainerPage>
  );
};

export default OwnerFormSubmissionsBrief;
